'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsListNative = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _OptionPropTypeNative = require('../OptionPropType/OptionPropTypeNative');

var _SelectElementStyled = require('./styles/SelectElementStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  fullWidth: _propTypes2.default.bool,
  dense: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  options: _propTypes2.default.arrayOf(_OptionPropTypeNative.OptionPropTypeNative),
  value: _propTypes2.default.number,
  disabled: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
  onChange: _propTypes2.default.func
};
var defaultProps = {
  fullWidth: false,
  dense: false,
  bordered: false,
  colorScheme: 'neutral',
  options: [],
  value: -1,
  disabled: false,
  placeholder: '',
  onChange: _reactackleCore.noop
};

var OptionsListNative = exports.OptionsListNative = function (_Component) {
  _inherits(OptionsListNative, _Component);

  function OptionsListNative(props) {
    _classCallCheck(this, OptionsListNative);

    var _this = _possibleConstructorReturn(this, (OptionsListNative.__proto__ || Object.getPrototypeOf(OptionsListNative)).call(this, props));

    _this._handleChange = _this._handleChange.bind(_this);
    return _this;
  }

  _createClass(OptionsListNative, [{
    key: '_handleChange',
    value: function _handleChange(event) {
      this.setState({
        value: event.target.value
      });
      this.props.onChange({
        value: this.props.options[event.target.value] || null
      });
    }
  }, {
    key: '_renderOptions',
    value: function _renderOptions() {
      if (!this.props.options.length) return null;
      return [_react2.default.createElement('option', {
        value: -1,
        key: -1,
        disabled: true
      }, this.props.placeholder)].concat(_toConsumableArray(this.props.options.map(function (item, idx) {
        return _react2.default.createElement('option', {
          value: idx,
          key: (0, _reactackleCore.getKey)(item, idx),
          disabled: item.disabled || false
        }, item.text);
      })));
    }
  }, {
    key: 'render',
    value: function render() {
      var options = this._renderOptions();

      return _react2.default.createElement('div', null, _react2.default.createElement(_SelectElementStyled.SelectElementStyled, {
        value: this.props.value,
        disabled: this.props.disabled,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth,
        bordered: this.props.bordered,
        colorScheme: this.props.colorScheme,
        onChange: this._handleChange
      }, options));
    }
  }]);

  return OptionsListNative;
}(_react.Component);

OptionsListNative.propTypes = propTypes;
OptionsListNative.defaultProps = defaultProps;
OptionsListNative.displayName = 'OptionsListNative';